import { render, staticRenderFns } from "./GenericCreateMSList.vue?vue&type=template&id=6e9c5df6&scoped=true"
import script from "./GenericCreateMSList.vue?vue&type=script&lang=js"
export * from "./GenericCreateMSList.vue?vue&type=script&lang=js"
import style0 from "./GenericCreateMSList.vue?vue&type=style&index=0&id=6e9c5df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c5df6",
  null
  
)

export default component.exports